export const LOCALSTORAGE_TOKEN_LABEL = 'occdec-annotator-ui-user-token';

export const LOCALSTORAGE_EVENT_FILTER_LABEL =
  'occdec-annotator-ui-event-filter';

export const HEADER_LINKS = [
  {
    label: 'Dashboard',
    path: '/',
  },
  {
    label: 'All Events',
    path: '/events',
  },
];
